import { SlideType } from '@boltenergy-be/design-system'
import { Greenpeace, Lecho, Lesoir, Nieuwsblad, Testaankoop, Testachats, Tijd } from './assets/logos'

export const HERO_VARIANTS = ['inside', 'outside-all', 'outside-mobile'] as const
export type HeroVariant = (typeof HERO_VARIANTS)[number]
export const CURRENT_HERO_VARIANT: HeroVariant = 'outside-mobile'

export const TESTIMONIALS_NL: SlideType[] = [
  {
    id: 'testaankoop',
    img: { publicId: 'website/home/groen-beleven', alt: '' },
    quote: 'testimonial.testaankoop',
    caption: {
      logo: {
        type: 'element',
        element: <Testaankoop />
      }
    }
  },
  {
    id: 'greenpeace',
    img: { publicId: 'website/producers/francis', alt: '' },
    quote: 'testimonial.greenpeace',
    caption: {
      logo: {
        type: 'element',
        element: <Greenpeace />
      }
    }
  },
  {
    id: 'tijd',
    img: { publicId: 'website/producers/kevin-fatih', alt: '' },
    quote: 'testimonial.tijd',
    caption: {
      logo: {
        type: 'element',
        element: <Tijd />
      }
    }
  },
  {
    id: 'nieuwsblad',
    img: { publicId: 'website/producers/noel-co', alt: '' },
    quote: 'testimonial.nieuwsblad',
    caption: {
      logo: {
        type: 'element',
        element: <Nieuwsblad />
      }
    }
  }
]

export const TESTIMONIALS_FR: SlideType[] = [
  {
    id: 'testachats',
    img: { publicId: 'website/home/groen-beleven', alt: '' },
    quote: 'testimonial.testachats',
    caption: {
      logo: {
        type: 'element',
        element: <Testachats />
      }
    }
  },
  {
    id: 'greenpeace',
    img: { publicId: 'website/producers/francis', alt: '' },
    quote: 'testimonial.greenpeace',
    caption: {
      logo: {
        type: 'element',
        element: <Greenpeace />
      }
    }
  },
  {
    id: 'lecho',
    img: { publicId: 'website/producers/kevin-fatih', alt: '' },

    quote: 'testimonial.lecho',
    caption: {
      logo: {
        type: 'element',
        element: <Lecho />
      }
    }
  },
  {
    id: 'lesoir',
    img: { publicId: 'website/producers/noel-co', alt: '' },
    quote: 'testimonial.lesoir',
    caption: {
      logo: {
        type: 'element',
        element: <Lesoir />
      }
    }
  }
]

export const TRUSTPILOT_REVIEWS_NL = [
  {
    documentId: 'sam-pauwel-5-nl',
    rating: 5,
    date: '2026/04/13',
    description:
      'Klant sinds januari 2026.\nVoordelig tarief, vlotte site en recent ook telefonisch geswitched van variabel naar vast contract, en dit op 2 min tijd.\nHeel vlotte ervaring, aan te raden.',
    thumbnailBg: '#DAFFE0',
    thumbnailTextColor: 'dark',
    author: 'Sam Pauwels'
  },
  {
    documentId: 'dirk-4-nl',
    rating: 4,
    date: '2026/07/30',
    description:
      'Enorme verbetering in customer service, fouten uit het verleden zijn weggewerkt. Toegankelijke klantendienst die met de klant kijkt naar een oplossing en of betaalplan.\nDoe zo verder',
    thumbnailBg: '#FFE1BA',
    thumbnailTextColor: 'dark',
    author: 'Dirk van Nispen'
  },
  {
    documentId: 'arlette-5-nl',
    rating: 5,
    date: '2026/08/12',
    description:
      'Ben zeer tevreden van Bolt. Als ge met een probleem zit en ge neemt contact op telefonisch of per e-mail, zijn ze onmiddellijk klaar om een oplossing te zoeken samen met de klant.',
    thumbnailBg: '#FFDDE8',
    thumbnailTextColor: 'dark',
    author: 'Arlette Knapik'
  }
] as const

export const TRUSTPILOT_REVIEWS_FR = [
  {
    documentId: 'didier-5-fr',
    rating: 5,
    date: '2026/08/25',
    description:
      'Contacté pour obtenir des renseignements concernant ma facturation et les tarifs, ainsi que pour des conseils par rapport à l’installation prochaine de panneaux photovoltaïques… J’ai non seulement eu réponse à mes questions rapidement, mais en plus avec sympathie, ce qui fait la différence ! Les prix sont corrects et transparents, mais selon moi le prix ne fait pas tout.',
    thumbnailBg: '#DAFFE0',
    thumbnailTextColor: 'dark',
    author: 'Didier Debroux'
  },
  {
    documentId: 'guillaume-5-fr',
    rating: 5,
    date: '2026/08/05',
    description:
      "Très content des 3 appels téléphoniques pour souscrire un contrat, vérifier que tout est prêt avant l'ouverture et voir si l'envoie de l'index du compteur est bien conforme.\nMerci pour le travail et votre impact !",
    thumbnailBg: '#FFDDE8',
    thumbnailTextColor: 'dark',
    author: 'Guillaume Champvillard'
  },
  {
    documentId: 'francoise-4-fr',
    rating: 4,
    date: '2026/06/06',
    description: 'Electricité verte et locale, service clientèle serviable et efficace :-)',
    thumbnailBg: '#FFE1BA',
    thumbnailTextColor: 'dark',
    author: 'Françoise Cantraine'
  }
] as const
